import {axiosType} from "./Type";

export const onChangeLoading = (params) => ({
    type: axiosType.ON_CHANGE_LOADING,
    params
})

export const onChangeSuccessAxios = (params) => ({
    type: axiosType.ON_CHANGE_SUCCESS_AXIOS,
    params
})
